import React from "react"
import styles from "./LoadingSpinner.module.css"

export default function LoadingSpinner() {
  return (
    <div className={styles.container} data-testid='loading-spinner'>
      <div className={styles.spinner}></div>
    </div>
  )
}